/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TestCaseVisibility } from './TestCaseVisibility';
import {
    TestCaseVisibilityFromJSON,
    TestCaseVisibilityFromJSONTyped,
    TestCaseVisibilityToJSON,
    TestCaseVisibilityToJSONTyped,
} from './TestCaseVisibility';
import type { TestCaseOutputRead } from './TestCaseOutputRead';
import {
    TestCaseOutputReadFromJSON,
    TestCaseOutputReadFromJSONTyped,
    TestCaseOutputReadToJSON,
    TestCaseOutputReadToJSONTyped,
} from './TestCaseOutputRead';
import type { TestCaseStatus } from './TestCaseStatus';
import {
    TestCaseStatusFromJSON,
    TestCaseStatusFromJSONTyped,
    TestCaseStatusToJSON,
    TestCaseStatusToJSONTyped,
} from './TestCaseStatus';

/**
 * 
 * @export
 * @interface TestCaseReadWithOutputs
 */
export interface TestCaseReadWithOutputs {
    /**
     * 
     * @type {string}
     * @memberof TestCaseReadWithOutputs
     */
    problem_id: string;
    /**
     * 
     * @type {string}
     * @memberof TestCaseReadWithOutputs
     */
    driver_code: string;
    /**
     * 
     * @type {number}
     * @memberof TestCaseReadWithOutputs
     */
    points: number;
    /**
     * 
     * @type {TestCaseVisibility}
     * @memberof TestCaseReadWithOutputs
     */
    visibility?: TestCaseVisibility;
    /**
     * 
     * @type {string}
     * @memberof TestCaseReadWithOutputs
     */
    id: string;
    /**
     * 
     * @type {TestCaseStatus}
     * @memberof TestCaseReadWithOutputs
     */
    status: TestCaseStatus;
    /**
     * 
     * @type {string}
     * @memberof TestCaseReadWithOutputs
     */
    official_output_id: string | null;
    /**
     * 
     * @type {TestCaseOutputRead}
     * @memberof TestCaseReadWithOutputs
     */
    official_output: TestCaseOutputRead | null;
}



/**
 * Check if a given object implements the TestCaseReadWithOutputs interface.
 */
export function instanceOfTestCaseReadWithOutputs(value: object): value is TestCaseReadWithOutputs {
    if (!('problem_id' in value) || value['problem_id'] === undefined) return false;
    if (!('driver_code' in value) || value['driver_code'] === undefined) return false;
    if (!('points' in value) || value['points'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('official_output_id' in value) || value['official_output_id'] === undefined) return false;
    if (!('official_output' in value) || value['official_output'] === undefined) return false;
    return true;
}

export function TestCaseReadWithOutputsFromJSON(json: any): TestCaseReadWithOutputs {
    return TestCaseReadWithOutputsFromJSONTyped(json, false);
}

export function TestCaseReadWithOutputsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestCaseReadWithOutputs {
    if (json == null) {
        return json;
    }
    return {
        
        'problem_id': json['problem_id'],
        'driver_code': json['driver_code'],
        'points': json['points'],
        'visibility': json['visibility'] == null ? undefined : TestCaseVisibilityFromJSON(json['visibility']),
        'id': json['id'],
        'status': TestCaseStatusFromJSON(json['status']),
        'official_output_id': json['official_output_id'],
        'official_output': TestCaseOutputReadFromJSON(json['official_output']),
    };
}

export function TestCaseReadWithOutputsToJSON(json: any): TestCaseReadWithOutputs {
    return TestCaseReadWithOutputsToJSONTyped(json, false);
}

export function TestCaseReadWithOutputsToJSONTyped(value?: TestCaseReadWithOutputs | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'problem_id': value['problem_id'],
        'driver_code': value['driver_code'],
        'points': value['points'],
        'visibility': TestCaseVisibilityToJSON(value['visibility']),
        'id': value['id'],
        'status': TestCaseStatusToJSON(value['status']),
        'official_output_id': value['official_output_id'],
        'official_output': TestCaseOutputReadToJSON(value['official_output']),
    };
}

